function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { SaveButton, EditButton, DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { Table } from '@rd-web-markets/shared/dist/util';
import elsterAssetInstanceFundingsService from '../../../../services/elster/elster_asset_instance_fundings.service';
import FundingDocument from './FundingDocument';
import { CloseButton } from '@rd-web-markets/shared/dist/util/buttons/CloseButton';
const ElsterAssetFunding = _ref => {
  let {
    assetInstanceId,
    loading: parentLoading,
    setParentHasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const [fundingsLoading, setFundingsLoading] = useState(false);
  const [showNewFundingForm, setShowNewFundingForm] = useState(false);
  const [newFunding, setNewFunding] = useState({
    amount: '',
    notes: ''
  });
  const [editingFundingId, setEditingFundingId] = useState(null);
  const [editedFundings, setEditedFundings] = useState({});
  const {
    fundings,
    setFundings,
    fetchFundings,
    createFunding,
    updateFunding: updateFundingService,
    deleteFunding: deleteFundingService
  } = elsterAssetInstanceFundingsService.useCrud(assetInstanceId, setFundingsLoading, false);
  useEffect(() => {
    if (assetInstanceId) {
      fetchFundings();
    }
    return () => {
      setFundings([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetInstanceId]);
  const changeNewFundingData = e => {
    const {
      name,
      value
    } = e.target;
    let processedValue = value;
    if (name === 'amount') {
      processedValue = value === '' ? '' : parseFloat(value) || '';
    }
    setNewFunding(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [name]: processedValue
    }));
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
  };
  const createNewFunding = async () => {
    if (!newFunding.amount || newFunding.amount === '') return;
    await createFunding({
      funding: {
        amount: parseFloat(newFunding.amount),
        notes: newFunding.notes || ''
      }
    });
    setNewFunding({
      amount: '',
      notes: ''
    });
    setShowNewFundingForm(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const cancelNewFunding = () => {
    setNewFunding({
      amount: '',
      notes: ''
    });
    setShowNewFundingForm(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const startEditting = funding => {
    setEditingFundingId(funding.id);
    setEditedFundings(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [funding.id]: _objectSpread({}, funding)
    }));
  };
  const changeFunding = (fundingId, e) => {
    const {
      name,
      value
    } = e.target;
    let processedValue = value;
    if (name === 'amount') {
      processedValue = value === '' ? '' : parseFloat(value) || '';
    }
    setEditedFundings(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [fundingId]: _objectSpread(_objectSpread({}, prev[fundingId]), {}, {
        [name]: processedValue
      })
    }));
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
  };
  const updateFunding = async (funding, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const editedFunding = editedFundings[funding.id];
    if (!editedFunding || !editedFunding.amount || editedFunding.amount === '') return;
    const updatedFunding = await updateFundingService({
      id: editedFunding.id,
      amount: parseFloat(editedFunding.amount),
      notes: editedFunding.notes || ''
    });
    setFundings(prevFundings => {
      return prevFundings.map(f => f.id === updatedFunding.id ? updatedFunding : f);
    });
    setEditingFundingId(null);
    setEditedFundings(prev => {
      const newState = _objectSpread({}, prev);
      delete newState[funding.id];
      return newState;
    });
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const cancelEditting = funding => {
    // Reset to original state
    setFundings(prevFundings => {
      return prevFundings.map(f => f.id === funding.id ? _objectSpread({}, funding) : f);
    });
    setEditingFundingId(null);
    setEditedFundings(prev => {
      const newState = _objectSpread({}, prev);
      delete newState[funding.id];
      return newState;
    });
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const deleteFunding = async funding => {
    await deleteFundingService(funding);
  };
  const isLoading = fundingsLoading || parentLoading;
  const headers = [{
    text: t('amount')
  }, {
    text: t('notes')
  }, {
    text: t('document')
  }, {
    text: t('actions')
  }];
  const buildRow = funding => {
    const isEditing = editingFundingId === funding.id;
    const editedFunding = editedFundings[funding.id] || funding;
    const originalFunding = funding;
    const hasUnsavedChanges = isEditing && originalFunding && (editedFunding.amount !== originalFunding.amount || editedFunding.notes !== originalFunding.notes);
    const columns = [/*#__PURE__*/React.createElement(Form.Control, {
      key: "amount-".concat(funding.id),
      type: "number",
      step: "0.01",
      min: "0",
      name: "amount",
      value: editedFunding.amount || '',
      onChange: e => changeFunding(funding.id, e),
      disabled: isLoading || !isEditing,
      size: "sm",
      "data-testid": "funding-amount-".concat(funding.id, "-test-id")
    }), /*#__PURE__*/React.createElement(Form.Control, {
      key: "notes-".concat(funding.id),
      type: "text",
      name: "notes",
      value: editedFunding.notes || '',
      onChange: e => changeFunding(funding.id, e),
      disabled: isLoading || !isEditing,
      size: "sm",
      "data-testid": "funding-notes-".concat(funding.id, "-test-id")
    }), /*#__PURE__*/React.createElement(FundingDocument, {
      key: "document-".concat(funding.id),
      funding: funding,
      setFundings: setFundings,
      setParentHasUnsavedChanges: setParentHasUnsavedChanges,
      isLoading: isLoading
    }), isEditing ? /*#__PURE__*/React.createElement("div", {
      key: "actions-".concat(funding.id)
    }, /*#__PURE__*/React.createElement(SaveButton, {
      onClick: e => updateFunding(funding, e),
      disabled: isLoading || !editedFunding.amount || editedFunding.amount === '',
      className: "mx-1",
      size: "sm",
      type: "button"
    }), /*#__PURE__*/React.createElement(CloseButton, {
      onClick: () => cancelEditting(funding),
      disabled: isLoading,
      className: "mx-1",
      size: "sm"
    }), hasUnsavedChanges && /*#__PURE__*/React.createElement("span", {
      className: "text-muted ms-2"
    }, t('not_saved'))) : /*#__PURE__*/React.createElement("div", {
      key: "actions-".concat(funding.id)
    }, /*#__PURE__*/React.createElement(EditButton, {
      onClick: () => startEditting(funding),
      disabled: isLoading,
      className: "mx-1",
      size: "sm"
    }), /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: () => deleteFunding(funding),
      disabled: isLoading,
      className: "mx-1",
      size: "sm",
      variant: "danger"
    }))];
    return {
      key: funding.id,
      columns: columns
    };
  };
  const rows = (fundings === null || fundings === void 0 ? void 0 : fundings.map(funding => buildRow(funding))) || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3 mt-4"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    style: {
      height: '100px',
      display: 'flex',
      alignItems: 'center'
    }
  }, t('fundings'), isLoading && /*#__PURE__*/React.createElement("span", {
    className: "ms-2",
    style: {
      height: '100px',
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, !showNewFundingForm ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      setShowNewFundingForm(true);
      if (setParentHasUnsavedChanges) {
        setParentHasUnsavedChanges(false);
      }
    },
    variant: "primary",
    disabled: isLoading,
    className: "mb-3",
    "data-testid": "add-new-funding-button-test-id"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_new_funding')) : /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('amount'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    type: "number",
    step: "0.01",
    min: "0",
    name: "amount",
    value: newFunding.amount,
    onChange: changeNewFundingData,
    disabled: isLoading,
    "data-testid": "new-funding-amount-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('notes')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "notes",
    value: newFunding.notes,
    onChange: changeNewFundingData,
    disabled: isLoading,
    "data-testid": "new-funding-notes-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    className: "ms-2",
    onClick: createNewFunding,
    disabled: isLoading || !newFunding.amount || newFunding.amount === '',
    text: t('add_new_funding')
  }), /*#__PURE__*/React.createElement(CloseButton, {
    className: "ms-2",
    onClick: cancelNewFunding,
    disabled: isLoading
  }))))))), fundings && Array.isArray(fundings) && fundings.length > 0 && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    opts: {
      bordered: false,
      striped: false,
      responsive: true,
      hover: true
    }
  }))));
};
export default ElsterAssetFunding;